<template>
  <div class="content">
    <div class="header">
      标签详情
    </div>
    <div class="bottom">
      <div class="box">
        <div class="header">
          基本信息
        </div>
        <div class="basic">
          <div>
            <div class="top">符合标签人数</div>
            <div class="text">{{ details.user_num }}</div>
          </div>
          <div>
            <div class="top">标签创建时间</div>
            <div class="text">{{ details.create_time }}</div>
          </div>
          <div>
            <div class="top">标签数据更新时间</div>
            <template v-if="is_status == '1'">
              <div
                class="text"
                v-if="details.change_time == '1970-01-01 08:00:00'"
              >
                ---
              </div>
              <div class="text" v-else>{{ details.change_time }}</div>
            </template>
            <template v-if="is_status == '2'">
              <div class="text">{{ details.update_time }}</div>
            </template>
          </div>
        </div>
        <div v-if="is_status == '1'">
          <div class="header">
            标签条件
          </div>
          <div class="condition">
            <div>满足以下所有条件的用户：</div>
            <div v-if="sexArray.length != 0" class="flex">
              性别：
              <div v-for="(item, index) in sexArray" :key="index">
                {{ item == 1 ? "男" : "" }}
                {{ item == 2 ? "女" : "" }}
                {{ item == 3 ? "未知" : "" }}
              </div>
            </div>
            <div v-if="ageArray.length != 0" class="flex">
              年龄范围：{{ ageArray[0] }} 至 {{ ageArray[1] }} 岁
            </div>
            <div v-if="brithdayageArray.length != 0" class="flex">
              生日：{{ brithdayageArray[0] }} 至 {{ brithdayageArray[1] }}
            </div>
            <div v-if="details.area.length != 0" class="flex">
              地域：
              <div v-for="(item, index) in details.area" :key="index">
                <span class="margin2">{{ item }}</span>
              </div>
            </div>
            <div v-if="details.level_id != ''" class="flex">
              会员等级：
              <div>
                <span class="margin2">{{ details.level_name }}</span>
              </div>
            </div>
            <div v-if="subscribeTime.length != 0" class="flex">
              关注时间：{{ subscribeTime[0] }} 至 {{ subscribeTime[1] }}
            </div>
            <div v-if="take_cardTime.length != 0" class="flex">
              领卡时间：{{ take_cardTime[0] }} 至 {{ take_cardTime[1] }}
            </div>
            <div v-if="take_cardSource.length != 0" class="flex">
              领卡渠道：
              <div v-for="(item, index) in take_cardSource" :key="index">
                {{ item == 1 ? "微信公众号" : "" }}
                {{ item == 2 ? "微信小程序" : "" }}
                {{ item == 3 ? "支付宝" : "" }}
              </div>
            </div>
            <div v-if="balanceArray.length != 0" class="flex">
              可用余额：{{ balanceArray[0] }} 至 {{ balanceArray[1] }} 元
            </div>
            <div v-if="pointArray.length != 0" class="flex">
              可用积分：{{ pointArray[0] }} 至 {{ pointArray[1] }} 积分
            </div>
            <div v-if="customNum.length != 0" class="flex">
              可用消费次数：{{ customNum[0] }} 天内累计消费
              {{ customNum[1] }} 至{{ customNum[2] }}次
            </div>
            <div v-if="last_customDay.length != 0" class="flex">
              上次消费距今天数：上次消费距今
              {{ last_customDay[0] }} 至{{ last_customDay[1] }}天
            </div>
            <div v-if="totalCustom.length != 0" class="flex">
              累计消费金额：{{ totalCustom[0] }} 天内累计消费
              {{ totalCustom[1] }} 至{{ totalCustom[2] }}元
            </div>
            <div v-if="avgCustom.length != 0" class="flex">
              平均消费金额：{{ avgCustom[0] }} 天内平均消费
              {{ avgCustom[1] }} 至{{ avgCustom[2] }}元
            </div>
            <div v-if="rechargeNum.length != 0" class="flex">
              充值次数：{{ rechargeNum[0] }} 天内累计充值
              {{ rechargeNum[1] }} 至{{ rechargeNum[2] }}次
            </div>
            <div v-if="last_rechargeDay.length != 0" class="flex">
              上次充值距今天数：上次充值距今
              {{ last_rechargeDay[0] }} 至{{ last_rechargeDay[1] }}天
            </div>
            <div v-if="totalRecharge.length != 0" class="flex">
              累计实充金额：{{ totalRecharge[0] }} 天内累计充值
              {{ totalRecharge[1] }} 至{{ totalRecharge[2] }}元
            </div>
            <div v-if="avgRecharge.length != 0" class="flex">
              平均实充金额：{{ avgRecharge[0] }} 天内平均充值
              {{ avgRecharge[1] }} 至{{ avgRecharge[2] }}元
            </div>
            <div v-if="totalPoint.length != 0" class="flex">
              累计获取积分：{{ totalPoint[0] }} 天内累计获取
              {{ totalPoint[1] }} 至{{ totalPoint[2] }}积分
            </div>
            <div v-if="no_recharge" class="flex">
              未充值过
            </div>
          </div>
        </div>
        <div class="option">
          <div>符合标签用户详情</div>
          <el-button size="small" @click="showDelUser = true">
            删除会员
          </el-button>
          <el-button size="small" @click="showChangeLevel = true">
            会员调级
          </el-button>
          <el-button size="small" @click="showSendCoupon = true">
            发送优惠券
          </el-button>
          <el-button size="small" @click="Export">导出</el-button>
        </div>
        <el-table :data="details.users.result" style="width: 100%;">
          <el-table-column
            prop="card_num"
            label="卡号"
            width="180"
          ></el-table-column>
          <el-table-column
            prop="create_time"
            label="开卡时间"
          ></el-table-column>
          <el-table-column prop="real_name" label="姓名"></el-table-column>
          <el-table-column prop="card_level" label="等级"></el-table-column>
          <!-- <el-table-column prop="real_name" label="头像" width="180"></el-table-column> -->
          <el-table-column label="性别">
            <template slot-scope="scope">
              <span>
                {{
                  scope.row.sex == 1 ? "男" : scope.row.sex == 2 ? "女" : "未知"
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="mobile" label="手机号"></el-table-column>
          <el-table-column label="余额">
            <template slot-scope="scope">
              <span>
                {{
                  (
                    Number(scope.row.balance) +
                    Number(scope.row.oil_card_balance)
                  ).toFixed(2)
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="point" label="积分"></el-table-column>
          <el-table-column label="操作" width="80px" v-if="is_status == '2'">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="danger"
                @click="delItem(scope.row.id)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 10px;">
          <el-pagination
            layout="prev, pager, next, total"
            :current-page="userPage"
            :total="userTotal"
            :page-size="10"
            background
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 发送优惠券弹窗 -->
    <el-dialog
      :visible.sync="showSendCoupon"
      title="发送优惠券"
      @close="closeSend"
      width="700px"
    >
      <!-- 选择发布方式 -->
      <div>
        <div class="" style="text-align: center;">
          <span>发送方式：</span>
          <el-radio v-model="CouponType" label="1">多券发布</el-radio>
          <el-radio v-model="CouponType" label="2">单券多张</el-radio>
        </div>
      </div>
      <!-- 多卷发布 -->
      <div class="single" v-if="CouponType == '1'">
        <el-form label-width="90px" size="">
          <!-- <el-form-item label="发送给" style="margin-bottom:0">
            {{sendCouponUserName}}
          </el-form-item> -->
          <el-form-item label="优惠券">
            <el-tag
              v-for="(tag, idx) in sList"
              :key="tag.id"
              closable
              @close="delTagItem(idx)"
              style="margin-bottom: 5px; margin-right: 5px;"
            >
              {{ tag.name }}
            </el-tag>
            <el-button size="small" @click="showSelecter = true">
              选择
            </el-button>
          </el-form-item>
          <verificationCodeVue v-model="code_num" v-if="sms_stats.open_sms_coupon == 1"></verificationCodeVue>
          <!-- <el-form-item
            label="验证码"
            style="width: 386px;"
            v-if="sms_stats.open_sms_coupon == 1"
          >
            <el-input class="input_box" v-model="code_num">
              <template slot="append">
                <el-link :disabled="btn_status" @click="getCode" type="primary">
                  {{ code_text }}
                </el-link>
              </template>
            </el-input>
          </el-form-item> -->
        </el-form>
        <div style="text-align: center;">
          <el-button type="primary" @click="clickSend()">发送</el-button>
          <el-button @click="closeSend()">取消</el-button>
        </div>
      </div>
      <!-- 单卷多张 -->
      <div class="single" v-if="CouponType == '2'">
        <el-form label-width="90px" size="">
          <!-- <el-form-item label="发送给" style="margin-bottom:0">
            {{sendCouponUserName}}
          </el-form-item> -->
          <el-form-item label="优惠券" style="margin-bottom: 5px;">
            <el-tag
              v-if="couponOne.id != ''"
              :key="couponOne.id"
              style="margin-bottom: 5px; margin-right: 5px;"
            >
              {{ couponOne.name }}
            </el-tag>
            <el-button size="small" @click="showSelecterOne = true">
              选择
            </el-button>
          </el-form-item>
          <el-form-item label="每人送" style="margin-bottom: 5px;">
            <el-input
              v-model="everyoneNum"
              placeholder=""
              size="small"
              style="width: 100px; margin-right: 5px;"
            ></el-input>
            张
          </el-form-item>
          <verificationCodeVue v-model="code_num" v-if="sms_stats.open_sms_coupon == 1"></verificationCodeVue>
          <!-- <el-form-item
            label="验证码"
            style="width: 386px;"
            v-if="sms_stats.open_sms_coupon == 1"
          >
            <el-input class="input_box" v-model="code_num">
              <template slot="append">
                <el-link :disabled="btn_status" @click="getCode" type="primary">
                  {{ code_text }}
                </el-link>
              </template>
            </el-input>
          </el-form-item> -->
          <!-- <el-form-item label="">
            <el-checkbox v-model="timingSend">定时发送</el-checkbox>
          </el-form-item> -->
        </el-form>
        <div style="text-align: center;">
          <el-button type="primary" @click="clickSend()">发送</el-button>
          <el-button @click="closeSend()">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 多张优惠券发送1张 -->
    <el-dialog :visible.sync="showSelecter" @close="showSelecter = false">
      <selectCommodity
        @close="showSelecter = false"
        @getCommod="getCommod"
        :sList="sList"
        :jude="2"
        :menuName="'优惠券'"
      ></selectCommodity>
    </el-dialog>
    <!-- 单张优惠券发送多张 -->
    <el-dialog
      :visible.sync="showSelecterOne"
      @close="showSelecterOne = false"
      width="460px"
    >
      <selectCommodityOne
        @close="showSelecterOne = false"
        @getCommod="getCommodOne"
        :jude="2"
      ></selectCommodityOne>
    </el-dialog>
    <!-- 单券多张发送进度 -->
    <el-dialog
      :visible.sync="showSendPro"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      title="发送优惠券"
      center
    >
      <div style="text-align: center;">
        <div style="margin-bottom: 20px;">
          <el-progress type="circle" :percentage="sentPercent"></el-progress>
        </div>
        <div>
          <i class="el-icon-loading"></i>
          正在发送优惠券，请勿关闭网页。
        </div>
      </div>
    </el-dialog>
    <!-- 修改用户等级弹窗 -->
    <el-dialog
      :visible.sync="showChangeLevel"
      @close="closeChange"
      title="会员调级"
      width="600px"
    >
      <div>
        <el-form label-width="90px" size="">
          <el-form-item label="调级">
            <el-select
              v-model="change_level_id"
              placeholder="请选择"
              size="small"
            >
              <el-option
                v-for="item in level_options"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <verificationCodeVue v-model="code_num" v-if="sms_stats.open_update_level == 1"></verificationCodeVue>
          <!-- <el-form-item
            label="验证码"
            style="width: 386px;"
            v-if="sms_stats.open_update_level == 1"
          >
            <el-input class="input_box" v-model="code_num">
              <template slot="append">
                <el-link :disabled="btn_status" @click="getCode" type="primary">
                  {{ code_text }}
                </el-link>
              </template>
            </el-input>
          </el-form-item> -->
        </el-form>
        <div style="text-align: center;">
          <el-button type="primary" @click="clickChangeLevel()">确定</el-button>
          <el-button @click="closeChange()">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="showDelUser"
      title="删除会员"
      @close="showDelUser = false"
      width="700px"
    >
      <div>
        <el-form label-width="auto" size="">
          <verificationCodeVue v-model="code_num" v-if="sms_stats.open_delete_user == 1"></verificationCodeVue>
          <!-- <el-form-item
            label="验证码"
            style="width: 386px;"
            v-if="sms_stats.open_delete_user == 1"
          >
            <el-input class="input_box" v-model="code_num">
              <template slot="append">
                <el-link :disabled="btn_status" @click="getCode" type="primary">
                  {{ code_text }}
                </el-link>
              </template>
            </el-input>
          </el-form-item> -->
        </el-form>
      </div>

      <div>
        <div>提示：</div>
        <div>1.因会员卡只能领取一次，删除会员后用户无法再次注册为会员</div>
        <div>2.删除会员后不能恢复</div>
        <div>3.删除会员后订单无法显示用户信息</div>
        <div>请确认后慎重删除</div>
      </div>
      <div style="text-align: center;margin-top: 40px;">
        <el-button type="primary" @click="delUsers()">确定</el-button>
        <el-button @click="showDelUser = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import selectCommodity from "@/components/commodity/selectCommodity.vue";
import selectCommodityOne from "@/components/commodity/selectCommodity2.vue";
import { detailTag, detailCommonTag, delUserTag } from "@/api/market";
import { mapGetters } from "vuex";
import time from "@/utils/time";
import { SendAdminCode } from "@/api/set";
import {
  sendCoupon,
  sendCouponS,
  changeUserLevel,
  vipList,
  delete_user,
  exportMethods,
} from "@/api/vip";
import verificationCodeVue from "@Components/verification/verificationCode"
export default {
  inject: ["reload"],
  components: {
    selectCommodity,
    selectCommodityOne,
    verificationCodeVue
  },
  computed: {
    ...mapGetters(["token", "app_id"]),
  },
  data() {
    return {
      showDelUser: false,
      code_num: "",
      code_text: "获取验证码",
      btn_status: false,
      timer: null,
      sms_stats: {}, // 短信状态
      is_status: localStorage.getItem("signDetailsJude"),
      tableData: [],
      details: {
        area: [],
        users: {
          result: [],
        },
      },
      sexArray: [], //性别
      ageArray: [], //年龄区间
      brithdayageArray: [], // 开始生日日期
      subscribeTime: [], // 关注时间
      take_cardTime: [], // 领卡时间
      take_cardSource: [], //领卡渠道
      balanceArray: [], //可用余额
      pointArray: [], //可用积分
      customNum: [], //
      last_customDay: [],
      totalCustom: [], //
      avgCustom: [], //
      rechargeNum: [], //
      last_rechargeDay: [], //
      totalRecharge: [], //
      avgRecharge: [], //
      totalPoint: [], //
      showSendCoupon: false, //显示发送优惠券弹窗
      sendCouponUserName: "", // 发送优惠券的用户名
      showSelecter: false, // 选择优惠券弹窗
      showSelecterOne: false, // 选择优惠券弹窗 单张
      couponOne: { id: "" }, //单张优惠券信息
      sList: [], //已选择优惠券列表
      CouponType: "0", // 优惠券发布类型
      everyoneNum: "", //单券多张 张数
      showSendPro: false, //单券多张发送窗口
      sentPercent: 0, //单券多张发送进度
      showChangeLevel: false, //会员调级窗口
      change_level_id: "", //调整等级id
      level_options: [], //会员等级选项
      no_recharge: false, // 是否是未充值过的用户(新增)
      userPage: 1,
      userTotal: 0,
    };
  },
  async mounted() {
    this.getDetails();
    console.log("is_status", this.is_status);
    this.init();
    this.sms_stats = await this.get_prosms_ob();
  },
  methods: {
    delUsers() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        verification_code: this.code_num,
        tag_id: this.$route.query.id,
      };

      delete_user(data).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.userPage = 1;
          this.getDetails();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    Export() {
      let data = {
        Api: "user/agent.config_users_tag/user_level_card_export",
        app_id: this.app_id,
        params: [
          {
            name: "id",
            value: this.$route.query.id,
          },
          {
            name: "token",
            value: this.token,
          },
        ],
      };
      exportMethods(data);
    },
    init() {
      var data = {
        token: this.token,
        app_id: this.app_id,
      };
      vipList(data).then((res) => {
        if (res.code == 200) {
          res.data.forEach((item) => {
            this.level_options.push({ id: item.id, name: item.name });
          });
        } else {
        }
      });
    },
    getCode() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.SendMyCode();
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
            this.code_text = this.count + "s";
            this.btn_status = true;
          } else {
            this.btn_status = false;
            this.timer = null;
            this.code_text = "获取验证码";
          }
        }, 1000);
      }
    },
    // 管理员发送验证码
    async SendMyCode() {
      try {
        var data = { app_id: this.app_id };
        const res = await SendAdminCode(data);
        if (res.code == 200) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 分頁
    handleCurrentChange(val) {
      console.log("val", val);
      this.userPage = val;
      this.getDetails();
    },
    getDetails() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        id: this.$route.query.id,
        page: this.userPage,
      };
      if (this.is_status == 1) {
        detailTag(data).then((res) => {
          if (res.code == 200) {
            this.details = res.data;
            this.details.change_time = time.setTime(res.data.change_time);
            this.tableData = res.data.users;
            this.userTotal = res.data.users.total_num;
            this.details.area =
              (this.details.area == "") | (this.details.area == null)
                ? []
                : this.details.area;
            if (res.data.sex != "") this.sexArray = res.data.sex.split(",");
            if (res.data.age != "") this.ageArray = res.data.age.split(",");
            if (res.data.brithday != "")
              this.brithdayageArray = res.data.brithday.split(",");
            if (res.data.subscribe_time != "")
              this.subscribeTime = res.data.subscribe_time.split(",");
            if (res.data.take_card_time != "")
              this.take_cardTime = res.data.take_card_time.split(",");
            if (res.data.take_card_source != "")
              this.take_cardSource = res.data.take_card_source.split(",");
            if (res.data.balance != "")
              this.balanceArray = res.data.balance.split(",");
            if (res.data.point != "")
              this.pointArray = res.data.point.split(",");
            if (res.data.custom_num != "")
              this.customNum = res.data.custom_num.split(",");
            if (res.data.last_custom_day != "")
              this.last_customDay = res.data.last_custom_day.split(",");
            if (res.data.total_custom != "")
              this.totalCustom = res.data.total_custom.split(",");
            if (res.data.avg_custom != "")
              this.avgCustom = res.data.avg_custom.split(",");
            if (res.data.recharge_num != "")
              this.rechargeNum = res.data.recharge_num.split(",");
            if (res.data.last_recharge_day != "")
              this.last_rechargeDay = res.data.last_recharge_day.split(",");
            if (res.data.total_recharge != "")
              this.totalRecharge = res.data.total_recharge.split(",");
            if (res.data.avg_recharge != "")
              this.avgRecharge = res.data.avg_recharge.split(",");
            if (res.data.total_point != "")
              this.totalPoint = res.data.total_point.split(",");
            console.log(
              "标签custom_num",
              res.data.custom_num,
              this.customNum.length
            );
            this.no_recharge = res.data.is_recharge == 2 ? true : false;
          } else {
            this.$message.warning(res.msg);
          }
          console.log("标签详情", res);
        });
      } else if (this.is_status == 2) {
        detailCommonTag(data).then((res) => {
          if (res.code == 200) {
            this.details = res.data;
          }
        });
      } else {
        // this.$message.warning('非法访问！！')
      }
    },
    //选择优惠券 单张
    getCommodOne(data) {
      console.log(data);
      this.couponOne = data;
      this.showSelecterOne = false;
    }, //选择优惠券
    getCommod(data) {
      console.log(data);
      this.sList = data;
      this.showSelecter = false;
    },
    //删除已选择优惠券
    delTagItem(i) {
      this.sList.splice(i, 1);
    },
    //发送
    clickSend() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        verification_code: this.code_num,
        tag_id: this.$route.query.id,
      };
      // data.uid = this.sUserList.map(item => item.id).join(',');
      data.uid = "1";
      data.all = 1;

      if (this.CouponType == "1") {
        data.id = this.sList.map((i) => i.id).join(",");
        console.log(data);
        sendCoupon(data).then((res) => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "发送成功",
            });
            this.closeSend();
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        });
      } else {
        data.coupon_id = this.couponOne.id;
        data.num = this.everyoneNum;
        data.type_method = 1;
        data.batch = "";
        this.startSendCoupon(data);
        this.sentPercent = 0;
        this.showSendPro = true;
      }
    },
    // 开始发送单券多张
    startSendCoupon(data) {
      console.log("参数", data);
      var nextData = Object.assign({}, data);
      sendCouponS(data).then((res) => {
        if (res.code == 300) {
          //部分完成
          nextData.type_method = res.type_method;
          nextData.batch = res.batch;
          this.sentPercent = (Number(res.percent) * 100).toFixed(0);
          this.startSendCoupon(nextData);
        } else if (res.code == 200) {
          this.sentPercent = 100;
          this.$message({
            type: "success",
            message: "发送完成",
          });
          setTimeout(() => {
            this.showSendPro = false;
            this.showSendCoupon = false;
          }, 300);
        } else {
          this.$message(res.msg);
          setTimeout(() => {
            this.showSendPro = false;
          }, 300);
        }
      });
    },
    //关闭发送优惠券窗口
    closeSend() {
      this.sList = [];
      this.sUserList = [];
      this.selectUserName = "";
      this.showSendCoupon = false;
      this.CouponType = "0";
      this.num = "";
      clearTimeout(this.timer);
    },
    // 调级保存
    clickChangeLevel() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        user_level_id: this.change_level_id,
        uids: "",
        verification_code: this.code_num,
      };
      data.tag_id = this.details.id;
      console.log(data);
      // return false;
      changeUserLevel(data).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "修改成功",
          });
          this.closeChange();
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    // 关闭调级弹窗
    closeChange() {
      this.change_level_id = "";
      this.showChangeLevel = false;
    },
    //
    delItem(id) {
      console.log(id);
      this.$confirm("确定删除？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var data = {
            token: this.token,
            app_id: this.app_id,
            uid: id,
            tag_id: this.$route.query.id,
          };
          delUserTag(data).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "删除成功",
              });
              this.getDetails();
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        })
        .catch();
    },
  },
  destroyed: function() {
    console.log("我已经离开了！");
    localStorage.removeItem("signDetailsJude");
  },
};
</script>
<style lang="scss" scoped>
.content {
  width: 100%;

  background: #fff;
  padding: 10px;
  height: 100%;
  display: flex;
  flex-direction: column;
  .header {
    height: 56px;
    font-size: 14px;
    color: #595961;
    line-height: 34px;
    padding: 11px 0;
    display: flex;
    .btn {
      width: 100px;
      height: 36px;
      text-align: center;
      border-radius: 6px;
      margin-right: 5px;
      cursor: pointer;
    }
    .btnCurrent {
      color: #fff;
      background: #2589ff;
    }
  }
  .bottom {
    flex: 1;
    overflow-y: auto;
    .box {
      width: 100%;
      background: #f2f2f6;
      border-radius: 6px;
      padding: 10px;
    }
    .option {
      width: 100%;
      padding: 10px 20px;
      background-color: #fff !important;
      color: #595961;
      height: 50px;
      margin-bottom: 10px;
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      div {
        flex: 1;
      }
    }
    .el-table {
      background-color: #fff;
      border-radius: 6px;
      margin-bottom: 10px;
      min-height: 300px;
    }
  }
  .condition {
    padding: 20px;
    border-radius: 6px;
    background: #fff;
    margin-bottom: 10px;
    color: #595961;
    > div {
      margin-bottom: 10px;
    }
  }
  .basic {
    height: 95px;
    padding: 20px;
    display: flex;
    justify-content: space-between;
    background: #fff;
    border-radius: 6px;
    > div {
      width: 33%;
      > div {
        height: 50%;
        padding-left: 20px;
      }
      div:nth-child(1) {
        font-size: 14px;
      }
      div:nth-child(2) {
        font-size: 20px;
        font-weight: 550;
        color: #2589ff;
      }
    }
  }
}
.flex {
  display: flex;
}
.margin2 {
  margin-right: 6px;
}
</style>
